import { ApiService } from './../../../shared/services/api-service/api-service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { generateOtherSchoolsStudentGroupingsQuery } from 'Src/ng2/store/effects/projections/other-schools-student-groupings';
// TODO:
interface IFilter {
  filterKey: string;
  label: string;
  filterOptions: Array<{ graphQlKey: string; label: string }>;
}

interface IGrouping {
  graphQlKey: string;
  label: string;
}

interface IFocus {
  graphQlKey: string;
  label: string;
  isDefault: boolean;
  category: string;
  categoryOrder: string;
  fociOrder: string;
  filters: IFilter[];
  groupings: IGrouping[];
}

@Injectable()
export class SummerSchoolDataService {
  private fociCache$: Observable<any> = null;

  constructor(public apiService: ApiService) {}

  getSummerSchoolFocusData$(
    schoolId: string,
    focusKey?: string,
  ): Observable<{ data: { SummerSchoolListFocus: IFocus[] } }> {
    const payload = this.getSummerSchoolListFocusQuery(schoolId, focusKey);
    if (!focusKey) {
      if (!this.fociCache$) this.fociCache$ = this.apiService.getStudentsGraphQL(payload).pipe(shareReplay(1));
      return this.fociCache$;
    } else {
      return this.apiService.getStudentsGraphQL(payload);
    }
  }

  getSummerSchoolListGroupingData$(payload: {
    schoolId: string;
    filterKeys: string[];
    groupingKey: string;
    columns: string[];
  }) {
    // only want active students, so we append this filter behind the scenes
    payload.filterKeys.push('ACTIVE_ONLY');
    const query = generateOtherSchoolsStudentGroupingsQuery({ payload });
    return this.apiService.getStudentsGraphQL({ query, fetchPolicy: 'no-cache' });
  }

  getSummerSchoolListFocusQuery(schoolId: string, focusKey?: string) {
    const payload = focusKey ? `schoolId:"${schoolId}", focusKey:"${focusKey}"` : `schoolId:"${schoolId}"`;

    // fociOrder
    const query = `{
      SummerSchoolListFocus(${payload}) {
        graphQlKey
        label
        isDefault
        category
        categoryOrder
        filters {
          label
          filterOptions {
            graphQlKey
            label
            isDefault
          }
        }
        groupings {
          graphQlKey
          label
          requiresWildcard
          columns {
            graphQlKey
            label
            requiresWildcard
            columnDataFormat
            cellConfig
            cellTooltip
            headerTooltip {
              ...on SimpleTooltip {
                simpleContent
              }
              ...on TableTooltip {
                tableContent {
                  headers
                  rowData
                }
              }
            }
          }
        }

      }
    }`;
    return { query, fetchPolicy: 'no-cache' };
  }

  clearFociCache(): void {
    this.fociCache$ = null;
  }
}
